/** @jsxImportSource @emotion/react */
import { Card, CardProps, useMantineTheme } from '@mantine/core';
import { css } from '@emotion/react';
import React from 'react';

interface BenchCardRedProps extends CardProps {
  children: React.ReactNode;
}

const BenchCardRed = ({ children, ...cardProps }: BenchCardRedProps) => {
  const theme = useMantineTheme();

  const cardStyle = css`
    border: 1px solid ${theme.colors.red[6]};
    border-radius: ${theme.radius.lg};
    transition: all 0.2s ease-in-out;
  `;

  return (
    <Card css={cardStyle} {...cardProps}>
      {children}
    </Card>
  );
};

export default BenchCardRed;
